export default __webpack_public_path__ + "static/media/logo-green.cd289523.png";